// @flow
import { RT_SET_FOLLOWED_AIRCRAFT, RT_SET_FEATURES } from 'actions/rt';

const INITIAL_STATE = {
  features: [],
  followedAircraft: null,
  rtTourSeen: localStorage.rt_tour_seen || false,
};

export default function reduce(state = INITIAL_STATE, { type, ...payload }) {
  switch (type) {
    case RT_SET_FOLLOWED_AIRCRAFT: {
      const { followedAircraft } = payload;
      return {
        ...state,
        followedAircraft,
      };
    }

    case RT_SET_FEATURES: {
      const { features } = payload;
      return {
        ...state,
        features,
      };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/rt.js